import type { Theme } from "@mui/material";
import { useMediaQuery } from "@mui/material";

export function useShowSidebar(): boolean {
  return useMediaQuery((x: Theme) => x.breakpoints.up("lg"), { noSsr: true });
}
